import { FC } from "react";
import { Tooltip, Typography } from "@mui/material";
import numeral from "numeral";
import { MetricsKey } from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsTypes";
import { metricsUnit } from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsConstants";
import { convertSecondsToUnits } from "@/components/utils/helpers/convertSecondsToUnits";

interface ResourceMetricsAggregationProps {
  aggregation?: number | null;
  metricKey: MetricsKey;
}

export const ResourceMetricsAggregation: FC<
  ResourceMetricsAggregationProps
> = ({ metricKey, aggregation }) => {
  const isCpuMetric = metricKey.includes("cpu");
  let tooltipPrefix = isCpuMetric ? "CPU Max: " : "";

  if (metricKey.includes("memory")) {
    tooltipPrefix = "Memory Max: ";
  }

  let formattedPoint =
    aggregation && !isCpuMetric
      ? numeral(aggregation).format("0.[00]a")
      : aggregation;

  const unit = metricsUnit[metricKey];
  const unitLabel = !!aggregation && unit.length === 1 && unit;

  if (unit?.toLowerCase() === "seconds") {
    const converted = convertSecondsToUnits(aggregation ?? 0);

    formattedPoint = converted.value.toFixed(1);
  }

  const typography = (
    <Typography
      variant="caption"
      color="text.secondary"
      fontSize={10}
      width={50}
      textTransform="uppercase"
      textAlign="right"
    >
      {formattedPoint ?? "N/A"}
      {unitLabel}
    </Typography>
  );

  if (aggregation && formattedPoint !== `${aggregation}`) {
    let tooltipTitle = `${tooltipPrefix}${numeral(aggregation).format("0,0.[00]")} ${
      unit
    }`;

    if (unit?.toLowerCase() === "seconds" && aggregation) {
      const converted = convertSecondsToUnits(aggregation);

      tooltipTitle = `${converted.value.toFixed(1)} ${converted.label}`;
    }

    return (
      <Tooltip title={tooltipTitle} arrow placement="left">
        {typography}
      </Tooltip>
    );
  }

  return typography;
};
